// ©2024 Austin App House. All rights reserved.
import React, {useEffect, useRef, useState} from "react";
import DataTable from "react-data-table-component";
import {useDataTable} from "./useDataTable";
import RdtPagination from "./RdtPagination";
import {TableWrapper, FiltersWrapper} from "./styled";
import {MDBIcon} from "mdbreact";
import { registerFiltersHandlers } from "./filtersBus";

export const ResourceDataTable = ({ entity, Filters, className, onData, ...props }) => {
  const [query, setQuery] = useState({})
  const [reset, setReset] = useState({})
  const {context, setFilters} = useDataTable(entity, props)
  const didMountRef = useRef(false)

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true
      return
    }
    setFilters(props.filters ?? {})
  }, [reset])

  useEffect(() => {
    if (typeof onData === 'function') {
      onData(context.data)
    }
  }, [context.data])

  useEffect(() => {
    registerFiltersHandlers({
      onApply: (payload) => setFilters(payload),
      onReset: () => setReset(prev => !prev)
    })
  }, [setFilters])

  return (<TableWrapper className={className}>
    {Filters && <FiltersDropdown toggleModal={props.toggleModal} />}
    <DataTable
      className={className}
      columns={context.columns}
      data={context.data.payload}
      pagination
      paginationServer
      sortServer
      paginationComponent={RdtPagination}
      paginationRowsPerPageOptions={[5, 15, 30]}
      paginationTotalRows={context.data.total}
      paginationPerPage={+context.perPage}
      paginationDefaultPage={+context.page}
      progressPending={context.pending}
      progressComponent={<>loading ...</>}
      onChangePage={page => context.setPage(page)}
      onChangeRowsPerPage={perPage => context.setPerPage(perPage)}
      onSort={(column, direction) => {
        context.setSortBy(column.sortField)
        context.setSortDirection(direction === "asc"? 1: -1)
      }}
      theme="sourcew9"
    />
  </TableWrapper>)
}

const FiltersDropdown = ({ children, onReset, onApply, toggleModal }) => {
  const wrapperRef = useRef(null)
  const buttonRef = useRef(null)
  const [open, setOpen] = useState(false);

  useOnOutsideClick(() => {
    setOpen(false)
  }, [wrapperRef, buttonRef])

  return <FiltersWrapper>
    <button ref={buttonRef} className="standard_btn icon_filter green_btn" style={{top: '-74px'}} onClick={() => toggleModal(true, 'admminFilters')}>
      Filters
    </button>
    <div ref={wrapperRef} className={"position-absolute card text-dark d-none"} style={{zIndex: 999999, top: '-15px'}}></div>
  </FiltersWrapper>
}

const useOnOutsideClick = (handler = () => void 0, refs) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (!refs.filter((ref) => ref.current).some(ref => ref.current.contains(event.target))) {
        handler();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, refs);
}
